module.exports = __webpack_public_path__ + "static/media/RUBI_main_logo_x.ab92c026.png";